import apiClient from './client';

export const vendorsAPI = {
  getAll: async () => {
    const response = await apiClient.get('/vendors/');
    return response.data;
  },

  create: async (name) => {
    const response = await apiClient.post('/vendors/', { name });
    return response.data;
  },
};
